@import "src/styles/common/_colors.scss";
.dropdown {
  a {
    color: $white;
  }
  .btnIconRight {
    margin-right: 3px;
  }
  .btnIconLeft {
    margin-right: 3px;
  }

  .subMenu {
    width: 100%;
    display: block;

    .dropdownToggle {
      background: none !important;
      padding: 0px !important;
      line-height: 16px !important;
      display: flex !important;
      align-items: center;
      justify-content: space-between;
      position: relative;
      padding-right: 16px !important;
      font-size: 16px;
      color: $white;
      border: none !important;
      text-shadow: none !important;
      box-shadow: none !important;
      border-radius: 0px;
      background: none !important;
      width: 100% !important;
      .buttonText {
        float: none !important;
        width: auto !important;
        flex: 1 1 auto;
        padding-right: 12px;
        font-size: 12px !important;
        text-align: start !important;
      }
    }

    .dropdownToggle::after {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      margin-left: 0 !important;
      margin-bottom: 0 !important;
      vertical-align: middle !important;
    }
  }
  .dropdownTtoggle {
    border-top: 4px solid $white;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
    content: "";
    background: $black;
    padding: 8px 9px 8px 6px;
    font-size: 12px;
    line-height: 10px !important;
    font-size: 11px;
    border-radius: 3px;
    background: linear-gradient(180deg, $gray 0, $black);
    text-shadow: 0 1px 1px $mightnight-black;
    box-shadow: 0 1px 1px $gray-variant-9;
    border: 1px solid $black;
    .btnPrimary {
      --bs-btn-border-color: $black !important;
      --bs-btn-border-color: none !important;
      --bs-btn-active-border-color: $black !important;
    }
    &.noBorder {
      text-shadow: none;
      box-shadow: none;
      border: none;
    }
  }
  .dropdownMenu {
    font-size: 14px !important;
    background-color: $black;
    border: 1px solid $mightnight-black;
    border-radius: 6px;
    box-shadow: 0 5px 10px $smoke-black;
    background-clip: padding-box;
    min-width: 100%;
    .dropdownMenu {
      max-height: 80vh;
      overflow-y: auto;
    }

    a {
      display: block;
    }
    .iconFontSize {
      font-size: 9px;
      padding-right: 6px;
    }
    input {
      font-size: 12px;
      display: block;
      width: 95%;
      margin: 0 auto;
    }
    .dropdownIconItem {
      text-align: center;
    }

    .dropdownItem,
    :global(.dropdown-item) {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 5px;
      width: 100%;
      line-height: 16px;
      color: $white;
      font-size: 12px;
      padding: 4px 10px !important;
      min-height: 24px;
      margin: 0 !important;
      box-sizing: border-box;
      text-align: left;
      white-space: nowrap;
    }

    :global(.dropdown-item > *) {
      margin: 0;
    }

    .dropdownItem.disabled {
      color: $smoke-white;
      pointer-events: none;
    }
    .dropdownItem.hidden {
      display: none;
    }
    .dropdownItem:hover,
    .dropdownItem:focus {
      background-color: $dark-green !important;
      border-radius: 3px !important;
    }

    .dropdownDivider {
      background-color: $white;
      height: 1px;
      margin: 9px 1px;
    }
  }
  .dropdownScroll {
    max-height: 300px;
    overflow-y: scroll;
  }
}
.dropdown_disabled {
  pointer-events: none;
  opacity: 0.6;
}

.leftDropdownIcon {
  margin-right: 3px;
  font-size: 17px;
}

:global .dropdown {
  .show {
    color: $tile-white !important;

    .dropdown-caret {
      border-top: 4px solid $tile-white !important;
    }
  }
}

:global .dropdown-toggle::after {
  display: inline-block;
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
  font-size: 16px;
  margin-left: 5px;
  margin-bottom: -3px;
}

.flex {
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: flex-start;
}

.iconLeft {
  flex-direction: row-reverse;
  justify-content: flex-end !important;
  gap: 0px;
}

.enlarged {
  font-weight: 900;
  font-size: 16px;
  vertical-align: middle;
  color: $green-2;
}
